import ResumeThree from "./TemplateThree";

export default ResumeThree;
